import { render, staticRenderFns } from "./login_pc.vue?vue&type=template&id=84bb9466&scoped=true&"
import script from "./login_pc.vue?vue&type=script&lang=js&"
export * from "./login_pc.vue?vue&type=script&lang=js&"
import style0 from "./login_pc.vue?vue&type=style&index=0&id=84bb9466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bb9466",
  null
  
)

export default component.exports